import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { installE2eHarness } from './e2e/bootstrap';
import './styles/globals.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root not found.');
}

// Install the browser-side e2e harness (MSW + Clerk test-mode) when the page
// loads with ?e2e=1. In the normal production build this is a no-op (APP-002
// §34). Awaiting the harness before mount ensures no unintercepted requests
// leak to the network during e2e.
installE2eHarness()
  .catch(() => {
    // Swallow harness failures so the app still mounts (e2e tests assert via
    // MSW; a failed worker start surfaces as unintercepted requests).
  })
  .finally(() => {
    createRoot(container).render(
      <StrictMode>
        <App />
      </StrictMode>,
    );
  });
